import { Padrao } from '../generic/padrao';

export class AdendoPecasAplicacao extends Padrao{

    override idTab = 259;

    nome: string;
    ativo: string;
}